import {z} from 'zod'
import {SheetParser, ChartCfg, ChartMeta} from './chartMeta.types'
import {ChartType, colorNames} from './charts'
import {SimpleBars, SimpleBarsProps} from './SimpleBars'

const zodCause = z.object({
  cause: z.string().optional(),
  likelihood: z.number(),
  color: z.enum(colorNames).optional()
})

const parser: SheetParser<SimpleBarsCfg> = {
  cause: zodCause
}

const type: ChartType = 'SimpleBars'

type SimpleBarsCfg = ChartCfg<{
  cause: z.infer<typeof zodCause>[]
}> &
  Pick<SimpleBarsProps['chart'], 'title' | 'source'>

export const simpleBarsMeta: ChartMeta<SimpleBarsProps['chart'], SimpleBarsCfg> = {
  type,
  title: 'Likelihood bars',
  View: SimpleBars,
  edit: {
    initial: () => ({title: '', source: ''}),
    parser,
    cfgToProps: ({sheets, ...cfg}) => ({
      bars: sheets.cause?.map(c => ({value: c.likelihood, color: c.color, title: c.cause})),
      cfg
    }),
    cfgSchema: {}
  }
}
